<template>

  <b-tab :active="active" :lazy="lazy" :id="hash" @click="setHash()" class="container-tab-form" :disabled="disabled">
    <template #title>
      <div class="container-error-tab text-danger not-error"><b-spinner type="grow" small></b-spinner> {{title}}</div>
      <div class="title-tab-normal not-error">{{title}}</div>
    </template>
    <b-card style="padding-bottom: 0px" class="form-card">
      <slot></slot>
    </b-card>
  </b-tab>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    hash: {
      type: String,
      default: ""
    },
    disabled:Boolean,
    lazy:Boolean,
    active: Boolean,
  },
  methods: {
    setHash(){

      this.$emit('onClick')

      if(this.hash !== ''){
        window.location.hash = '#'+this.hash;
      }else{
        window.location.hash = '#default'
      }
    }
  }
}
</script>
